import React from 'react';
import { Divider } from 'antd';
import cn from 'classnames';
import styles from './FormDivider.module.scss';

const FormDivider = ({ className, ...props }) => {
  return <Divider className={cn(styles.root, className)} {...props} />;
};

export default FormDivider;
